// src/components/list/SecurityRoomSensor.tsx

import { MemoryTwoTone, TroubleshootTwoTone } from '@mui/icons-material'
import {
  Avatar,
  Collapse,
  Divider,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
} from '@mui/material'

import { FolderId, SensorRecord, SensorId } from '@/types/domain'

import { ToggleDateType } from '..'
import { sensorType } from '../../api'
import { useSecuritySensors, useSensorIcon } from '../../hooks'

type SecurityRoomSensorProps = {
  id: FolderId
  onClick: () => void
  sensorId: SensorId
}

export const SecurityRoomSensor = ({
  id: fId,
  onClick,
  sensorId: sId,
}: SecurityRoomSensorProps) => {
  const sSensors: SensorRecord[] = useSecuritySensors(fId)
  const sRecord: SensorRecord = sSensors.find(f => f.entity_id === sId)

  const {
    sensor_type,
    status,
    sub_sensor_target: sst,
    time,
    type_in_folder,
    value,
    unit,
  } = sRecord ?? {}

  const image_url = useSensorIcon(sId, status)
  const hrType = sensorType(sensor_type, type_in_folder, sst)
  const hrUnit: string = unit ?? ''
  const timestamp: Date = new Date(Date.parse(time))

  const SENSOR_SUPPORTS_HISTORY =
    sensor_type === 'pressure' ||
    sensor_type === 'temperature' ||
    sensor_type === 'temperature_0' ||
    sensor_type === 'temperature_1' ||
    sensor_type === 'temperature_2' ||
    sensor_type === 'external_temp_1' ||
    sensor_type === 'Ni1000' ||
    sensor_type === 'degrees-celsius'

  const SENSOR_SUPPORTS_VALUE =
    sensor_type !== 'waterDetected' &&
    sensor_type !== 'smokeDetektor' &&
    sensor_type !== 'external_digital_button'

  return sSensors.length === 0 ? null : (
    <Collapse in={true}>
      <ListItem>
        <ListItemAvatar>
          <Avatar src={image_url} sx={{ width: 40, height: 40 }}>
            {!image_url && <MemoryTwoTone />}
          </Avatar>
        </ListItemAvatar>

        <ListItemText
          primary={hrType}
          secondary={<ToggleDateType date={timestamp} />}
          sx={{ width: 0.7 }}
        />

        <ListItemText
          disableTypography
          primary={SENSOR_SUPPORTS_VALUE && `${value} ${hrUnit}`}
          sx={{
            display: 'flex',
            fontWeight: 'bold',
            justifyContent: 'flex-end',
            mr: 2,
            width: 0.3,
          }}
        />

        {SENSOR_SUPPORTS_HISTORY && (
          <>
            <Divider flexItem orientation={'vertical'} sx={{ mr: 2 }} />

            <Tooltip title={`Details ${hrType}`}>
              <IconButton onClick={onClick}>
                <TroubleshootTwoTone />
              </IconButton>
            </Tooltip>
          </>
        )}
      </ListItem>
    </Collapse>
  )
}
